import { render, staticRenderFns } from "./purchaseDetailInfo.vue?vue&type=template&id=068679ec&scoped=true&"
import script from "./purchaseDetailInfo.vue?vue&type=script&lang=js&"
export * from "./purchaseDetailInfo.vue?vue&type=script&lang=js&"
import style0 from "./purchaseDetailInfo.vue?vue&type=style&index=0&id=068679ec&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068679ec",
  null
  
)

export default component.exports